<template>
  <v-icon :disabled="disabled" class="backButton" @click="goBackUrl">
    arrow_back
  </v-icon>
</template>
<script>
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        disabled: false,
      };
    },
    computed: {
      ...mapGetters(["goBackRoute"]),
    },
    created() {
      this.goBackRoute == "#" ? (this.disabled = true) : "";
    },
    methods: {
      goBackUrl() {
        if (this.goBackRoute.includes("funding")) {
          this.$router.push(this.goBackRoute);
        } else {
          this.$router.back();
        }
      },
    },
  };
</script>
<style scoped>
  .backButton {
    position: fixed;
    left: 40px;
    font-size: 50px;
    cursor: pointer;
  }
</style>
